import React, { useState } from 'react';

interface ProgressBarProps {
  label: string;
  current: number;
  total: number;
  missingItems?: string[];
}

const ProgressBar: React.FC<ProgressBarProps> = ({ label, current, total, missingItems = [] }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const percentage = total > 0 ? (current / total) * 100 : 0;
  const hasMissing = missingItems.length > 0;

  return (
    <div
      className="mb-3 last:mb-0 relative"
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      <div className="flex justify-between text-sm mb-1">
        <span className={`text-[#64748b] ${hasMissing ? 'cursor-help' : ''}`}>
          {label}
          {hasMissing && (
            <span className="ml-1 text-[#94a3b8] text-xs">(hover for details)</span>
          )}
        </span>
        <span className="text-[#0f172a] font-medium">
          {current}/{total}
        </span>
      </div>
      <div className="h-2 bg-black/[0.08] rounded-full overflow-hidden">
        <div
          className="h-full bg-[#16a34a] rounded-full transition-all"
          style={{ width: `${percentage}%` }}
        />
      </div>

      {/* Tooltip for missing items */}
      {showTooltip && hasMissing && (
        <div className="absolute left-0 top-full mt-2 z-50 bg-white border border-black/[0.08] rounded-lg shadow-xl p-3 min-w-[200px] max-w-[280px]">
          <div className="text-xs text-[#64748b] mb-2 font-medium">Missing / Not Available:</div>
          <ul className="space-y-1">
            {missingItems.map((item, index) => (
              <li key={index} className="flex items-center gap-2 text-sm text-[#475569]">
                <span className="w-1.5 h-1.5 rounded-full bg-[#94a3b8] flex-shrink-0" />
                {item}
              </li>
            ))}
          </ul>
          {/* Arrow pointer */}
          <div className="absolute -top-1.5 left-4 w-3 h-3 bg-white border-l border-t border-black/[0.08] transform rotate-45" />
        </div>
      )}
    </div>
  );
};

export default ProgressBar;
